/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Observation_Not_DraftInputs */

const es_co2_error_observation_not_draft = /** @type {(inputs: Error_Observation_Not_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta observación ya no es un borrador.`)
};

/**

* @param {Error_Observation_Not_DraftInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_observation_not_draft = /** @type {((inputs?: Error_Observation_Not_DraftInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Observation_Not_DraftInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_observation_not_draft(inputs)
});